import { useTranslation } from 'next-i18next'

import { ClientRender } from '@/components/shared/client-render'
import { VipSectionTitle } from '@/components/vip/shared/vip-section-title/VipSectionTitle'
import { GptSponsoredLeft } from '@/components-page/vip/advertisement/GptSponsoredLeft'
import { GptSponsoredRight } from '@/components-page/vip/advertisement/GptSponsoredRight'

export const VipSponsoredAds = () => {
  const { t } = useTranslation(['vip'])

  return (
    <>
      <VipSectionTitle title={t('sponsored_ads')} />

      <ClientRender>
        <GptSponsoredLeft />
        <GptSponsoredRight />
      </ClientRender>
    </>
  )
}
